import { render, staticRenderFns } from "./_look-up-data.vue?vue&type=template&id=0f834e27"
import script from "./_look-up-data.vue?vue&type=script&lang=js"
export * from "./_look-up-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports